import React, { useState } from 'react'
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material'

import { useTranslate } from 'react-admin'

import { CustomListItem } from './CustomListItem'
import { tracesObject, cleanKey, addIndentIfIsArrayIndex } from 'src/helper/MapperHelper'
import { maxCharactersToString } from 'src/helper/maxCharactersToString'
import HighlightAltIcon from '@mui/icons-material/HighlightAlt'
export const MapperComponent = (props) => {
  const { data, setCheckedNodes, checkedNodes, setSelected, selected } = props
  const [checkedBox, setCheckedBox] = useState([])
    const translate = useTranslate()
  // const [ checkedNodes , setCheckedNodes] = useState([]);
  // const [ selected , setSelected] = useState([]);

  const handleToggle = (value) => () => {
    const currentIndex = checkedBox.indexOf(value)
    const newChecked = [...checkedBox]
    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setCheckedBox(newChecked)
    let newVal = value.split(':')
    setSelected(newVal[0])
  }

  // useEffect(() => {
  //     let path = findProps(data, selected)
  //     if (path){
  //       setPath(path)
  //       return
  //     }
  //     if(!path){
  //       if(checkedNodes.length === 0){
  //         setPath('')
  //         return;
  //       }
  //       // let indent = []
  //       // let lenCheckedNodes = checkedNodes.length
  //       // let lastPosition = checkedNodes[lenCheckedNodes - 1]
  //       // let isNumber = !isNaN(Number(cleanKey(lastPosition)))
  //       // if(isNumber){
  //       //   if(cleanKey(checkedNodes[lenCheckedNodes - 1]) === selected){
  //       //     indent = checkedNodes[lenCheckedNodes - 1].split("__") //get indent from checkedNodes
  //       //   }
  //       // }
  //       // let select = addIndentIfIsArrayIndex(selected, indent[0])

  //       // ⇑ to save index position from a array in the path ej: ["productData", "room", "0"] ⇑
  //       if(checkedNodes.includes(selected)){
  //         setPath(checkedNodes)
  //         return
  //       }
  //     }
  // }, [selected, checkedNodes])

  tracesObject(data, checkedNodes)

  const object = Object.entries(data)
  return (
    <Card className='genericTransferCard' raised={false}>
      <CardHeader
        title={
          <div className='headerTitle'>{translate('ra.message.select_option')}</div>
        }
      />
      <Divider />
      <CardContent>
        <List
          component='nav'
          aria-labelledby='nested-list-subheader'
          className='cardList'
          // subheader={
          //   <ListSubheader component='div' id='nested-list-subheader'>
          //     Arbol JSON
          //   </ListSubheader>
          // }
        >
          {React.Children.toArray(
            object.map((element) => {
              let [key, value] = element
              let key_clean = cleanKey(key)
              // const labelId = `checkbox-list-label-${value}`
              return (
                <>
                  {typeof value !== 'object' || value == null ? (
                    <ListItemButton onClick={handleToggle(key)} selected={selected === key}>
                      <ListItemIcon>
                        {/* <Checkbox
                          edge='start'
                          checked={checkedBox.indexOf(key) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                        /> */}
                        <HighlightAltIcon />
                      </ListItemIcon>
                      <ListItemText primary={`${key_clean} : ${maxCharactersToString(value)}`} />
                    </ListItemButton>
                  ) : (
                    <>
                      {/* --------recursive------- */}
                      <CustomListItem
                        propKey={key}
                        propValue={value}
                        setCheckedBox={setCheckedBox}
                        checkedNodes={checkedNodes}
                        setCheckedNodes={setCheckedNodes}
                        indent={0}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </>
                  )}
                </>
              )
            })
          )}
        </List>
      </CardContent>
    </Card>
  )
}
